import { Inbox, WifiOff, Refresh } from '../icons'

export function EmptyState() {
  return (
    <div className="placeholder">
      <div className="p-icon"><Inbox /></div>
      <h3>Nessun dispositivo</h3>
      <p>Controlla la configurazione server.</p>
    </div>
  )
}

export function ErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="placeholder error">
      <div className="p-icon"><WifiOff /></div>
      <h3>Impossibile caricare i dispositivi</h3>
      <p>Il backend non è raggiungibile. Riproveremo automaticamente.</p>
      <div className="p-actions">
        <button className="btn btn--ghost" onClick={onRetry}>
          <Refresh /> Riprova
        </button>
      </div>
    </div>
  )
}

function SkeletonRow() {
  return (
    <div className="ctile ctile-skeleton">
      <div className="sk" style={{ width: 34, height: 34, borderRadius: 8 }}></div>
      <div style={{ flex: 1 }}>
        <div className="sk" style={{ width: '60%', height: 14 }}></div>
        <div className="sk" style={{ width: '40%', height: 10, marginTop: 6 }}></div>
      </div>
      <div className="sk" style={{ width: 44, height: 44, borderRadius: '50%' }}></div>
    </div>
  )
}

export function SkeletonGrid({ count = 9, isNarrow }: { count?: number; isNarrow: boolean }) {
  const cls = `device-grid compact-layout stacked${isNarrow ? ' single-col' : ''}`
  return (
    <section className={cls}>
      {Array.from({ length: count }).map((_, i) => <SkeletonRow key={i} />)}
    </section>
  )
}
